.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink);
  text-decoration: none;
}

.row:first-child {
  border-top: 0;
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 600;
}

.detail {
  font-size: 14px;
  color: var(--ink-2);
}
